(ns web3.components.top-nav
  (:require [re-frame-simple.db :as db]
            [web3.i18n :as i]
            [web3.view :as v]
            [web3.styles.units :as units]
            [web3.routing.core :as routing]
            [web3.components.widgets :as widgets]

            [web3.ui-state :as ui-state]
            [web3.screens.pro.utils :as pro-utils]

            [web3.screens.sponsor :as sponsor]
            [web3.screens.property :as property]
            [web3.utils :as utils]
            [web3.ui-state :as state]
            [web3.persistence.schema :as schema]
            [web3.hints.core :as hints]
            [clojure.string :as str]
            [web3.env :as env]
            [web3.routing.auxiliary :as aux]
            [web3.routing.utils :as ru]
            [web3.persistence.current-property :as current-property]
            [web3.icons.shapes :as shapes]
            [web3.view.hiccup :as hiccup]
            [web3.icons.nav :as nav-i]
            [web3.icons.actions :as actions]))

(defn icon-button
  "Format icon for toolbar"
  [{:keys [icon label size active?] :as attrs}]
  [(if (:href attrs) :a :div)
   (-> attrs
       (assoc :key (str (hash icon)))
       (dissoc :tooltip :active? :icon)
       (update :class str
               " flex justify-center items-center pad-all-2 round-100p cursor-pointer shadow-nav-button relative hover-appear-parent"
               " text-black "
               " top-nav-button "
               (when active? "top-nav-button--active")))
   (when label
     [:div.absolute.hover-appear-child.text-size-10.text-uppercase.text-center.text-center
      {:class "text-black"
       :style {:left -30
               :right -30
               :top 43}}
               ;:bottom -8

      label])
   (-> icon
       (hiccup/size (or size 29))
       (hiccup/styles {:color "black"}))])

(v/defview button-add
  {:component-did-mount
   #(js/setTimeout (partial hints/show! [:hint/home.global-add]) 200)}
  [icon-size inner-padding]
  [:a#button-add-anything.bg-black.round-3.inline-flex.items-center.hover-bg-black-hover.cursor-pointer.text-white
   {:style (let [size (+ icon-size (* inner-padding 2))]
             {:width (str size "rem")
              :height (str size "rem")})
    :href (routing/path-for [:add-anything/start])}
   [:div.flex-auto]
   (-> actions/add
       (hiccup/size (units/rem->px icon-size)))
   [:div.flex-auto]])

(def safari-fixed-styles {:transform "translateZ(0)"
                          :-webkit-backface-visibility "hidden"})

(v/defview fixed-button-add
  [{:as props
    :keys [min-height max-height mode]}]
  (let [scroll-y (:window/scroll-y @state/ui-globals)
        toolbar-height (max min-height
                            (- max-height scroll-y))
        icon-size 1.5
        inner-padding 1
        outer-size (-> icon-size
                       (+ (* 2 inner-padding))
                       (units/rem->px))
        top? (and (= mode :mode/nav-flexible)
                  (> toolbar-height (+ min-height (/ outer-size 2))))]
    [:div.right-0.z-4.pad-right-4
     {:style (merge
              {:padding-right 24}
              (if top?
                {:position "absolute"
                 :margin-top (-> outer-size
                                 (/ 2)
                                 (-))}
                (merge {:position "fixed"
                        :bottom 30}
                       safari-fixed-styles)))}
     (when (not= mode :mode/full-screen)
       [button-add icon-size inner-padding])]))

(defn toolbar-calculations
  "Calculate toolbar state (based on window scroll/height properties)"
  [{:keys [window/scroll-y
           min-height
           max-height] :as props}]
  (let [percent-visible (- 1 (/ (min scroll-y max-height) max-height))
        current-height (js/Math.round (max min-height (* max-height percent-visible)))]
    (merge props {:current-height current-height
                  :collapsed? (<= current-height min-height)
                  :expanded? (>= current-height max-height)
                  :percent-visible percent-visible})))

(defn welcome [{:keys [current-property active-modal?] :as props}]
  (when (and current-property
             (not (and active-modal?
                       (some-> (ru/get-route)
                               aux/parse-path
                               :router/form-modal
                               (as-> <> (or (str/includes? <> "welcome")
                                            (str/includes? <> "vimeo/257952775")))))))
    (let [inner-width (:window/inner-width @state/ui-globals)]
      [:div [:div.header-1.margin-bottom-2_5
             (let [scale-adjust (if (> inner-width 800)
                                  (-> (- inner-width 800)
                                      (/ 800)
                                      (+ 1)
                                      (min 1.75)) 1)
                   [font-size line-height] (map (comp #(str % "rem") #(* scale-adjust %) units/pt->rem) [50 54])]
               {:class "text-homeserve"
                :style (merge {
                               :transition "all 0.2s cubic-bezier(.2,0,.2,1)"
                               :font-size font-size
                               :line-height line-height
                               :-webkit-backface-visibility "hidden"})})
             (i/get :nav/welcome-title)]
       [:div.inline-block
        {:class "text-black"
         :style {:transition "opacity 0.2s ease"
                 :opacity (if current-property 1 0)}}
        [property/actionable-property {:href (routing/path-for [:properties/index])}
         current-property]
        (when-let [sponsor (first (:sponsors current-property))]
          [sponsor/actionable-sponsor {:href (routing/path-for [:account/sponsor])}
           sponsor])]])))

(defn icon-links [{:keys [minimal?
                          visible?]}]
  (let [active-root (or (some-> (db/get-in [:db/routers :router/drawer :handler])
                                (utils/keyword-root))
                        (some-> (db/get-in [:db/routers :router/root :handler])
                                (utils/keyword-root)))]
    [:div#navbar.pad-h-3.margin-top-3.fixed.left-0.top-0.right-0.z-4.flex.justify-around
     {:class (when-not minimal? "top-nav--show-tooltips")
      :style {:visibility (if visible?
                            "visible"
                            "hidden")
              :transition "opacity 0.2 cubic-bezier(.2,0,.2,1)"}}

     (when (and (not (ui-state/mobile?))
                (pro-utils/pro?))
       [icon-button
        {:icon (-> nav-i/pro-dashboard
                   (hiccup/styles {:transform "scale(0.95)"}))
         :href (routing/path-for [:pro/dashboard])
         :label (i/to-do "Dashboard")}])
     [icon-button
      {:icon (-> nav-i/home
                 (hiccup/styles {:transform "scale(0.95)"}))
       :href (routing/path-for [:home])
       :active? (= active-root "home")
       :label (i/get :nav-link/home)}]

     (when-let [property-id (:id (current-property/get-property))]
       [icon-button
        {:icon (-> nav-i/file
                   (hiccup/styles {:transform "scale(0.95)"}))
         :href (routing/path-for [:files
                                  :property-id property-id])
         :size 26
         :active? (= active-root "files")
         :label (i/get :i/files)}])
     [icon-button
      {:icon (-> nav-i/service-providers
                 (hiccup/styles {:transform "scale(0.95)"}))
       :href (routing/path-for [:service-providers/index])
       :size 26
       :active? (= active-root "service-providers")
       :class (str "top-nav-button "
                   (when (= active-root "service-providers") "top-nav-button--active"))
       :label (i/get :i/service-providers)}]
     [:div.flex-auto.mobile-hidden]
     (when-let [nickname (-> (current-property/get-property)
                             (schema/property-nickname))]
       [:a.flex.items-center.truncate.mobile-hidden
        {:key "current-property"
         :href (when minimal? (routing/path-for [:properties/index]))
         :class (str (if minimal? "cursor-pointer" "opacity-0 cursor-default")
                     " text-black")
         :style {:transition "opacity 0.2s cubic-bezier(.2,0,.2,1)"}}
        [:div.truncate.pad-v-2 nickname]
        (-> shapes/chevron-right
            (hiccup/size 12)
            (hiccup/class "margin-left-2 flex-none"))])
     [:div.flex-auto.mobile-hidden]
     ;; Play store icon in header(top-nav)
     [:div.flex.items-center
      [widgets/black-button
       {:href "https://play.google.com/store/apps/details?id=com.homeserveapp.homeserve"
        :target "_new"
        :class "text-white width-100p"
        :style {:margin-right 10
                :margin-top 5}}
       [:img {:style {:position "relative"
                      :top "-5px"}
              :src "/images/button-googleplay.svg"}]]]
     ;; Apple store icon in header(top-nav)
     [:div.flex.items-center
      [widgets/black-button
       {:href "https://itunes.apple.com/us/app/homeserve/id1455853537?ls=1&mt=8"
        :target "_new"
        :class "text-white width-100p"
        :style {:margin-right 10
                :margin-top 5}}
       [:img {:style {:position "relative"
                      :top "-4px"}
              :src "/images/button-appstore.svg"}]]]
     [icon-button
      {:icon (-> nav-i/account
                 (hiccup/styles {:transform "scale(0.95)"}))
       :href (routing/path-for [:account/menu])
       :class "top-nav-button"
       :label (i/get :nav-link/account)}]]))

(v/defview toolbar
  "Toolbar component. Animates as the user scrolls.

  Safari flicker when a fixed-position element changes its height,
  so we need to use different elements for the background, scrollable
  content, and fixed navbar."
  [{:keys [min-height max-height transition mode view/nav-content navigation-visible?] :as props}]

  (let [max-content-height max-height
        {:keys [window/inner-height window/scroll-y]} @state/ui-globals
        {:keys [collapsed? percent-visible max-height spacer-height]}
        (merge (toolbar-calculations {:min-height min-height
                                      :max-height max-height
                                      :window/scroll-y (.-scrollY js/window)})
               {:mode mode}
               (case mode
                 :mode/nav-collapsed {:percent-visible 0
                                      :collapsed? true
                                      :expanded? false
                                      :spacer-height min-height}
                 :mode/nav-flexible {:spacer-height max-height}
                 :mode/full-screen {:current-height inner-height
                                    :max-height inner-height
                                    :collapsed? false
                                    :expanded? true
                                    :spacer-height inner-height}))]

    [:div.relative.root

     ;; spacer
     [:div {:style {:transition "height 0.2s cubic-bezier(.2,0,.2,1)"
                    :height spacer-height}}]

     ;; gradient which stays above content (for collapsed state)
     [:div.overflow-hidden.w-100p.flex-none.top-0.right-0.left-0.z-3.fixed
      {:style {:height min-height
               :visibility (when (= mode :mode/full-screen) "hidden")}}
      [:div.absolute.top-0.left-0.right-0.z-1
       {:class "homeserve-background"
        :style {:height max-height
                :transition "height 0.2s cubic-bezier(.2,0,.2,1)"}}]]

     ;; gradient which sits behind content
     [:div.fixed.top-0.left-0.right-0.z-1
      {:class "homeserve-background"
       :style {:height max-height
               :transition "height 0.2s cubic-bezier(.2,0,.2,1)"}}]

     ;; top navigation icons are always in fixed position.
     (when navigation-visible?
       [icon-links {:minimal? (< percent-visible 0.4)
                    :visible? (or transition (not= mode :mode/full-screen))}])

     ;; content for expanded nav view is in lower z-position than page content
     [:div.fixed.top-0.left-0.right-0.overflow-hidden.z-1.transition-all
      {:style {:height (if (and (not transition)
                                (= mode :mode/full-screen))
                         max-height max-content-height)
               :opacity (if transition 0 1)}}
      [:div.pad-h-3.margin-h-2.flex.flex-column.absolute.top-0.left-0.right-0
       {:style {:opacity (if collapsed? 0 percent-visible)
                :transition "opacity 0.2s cubic-bezier(.2,0,.2,1)"
                :height (if (and (not transition)
                                 (= mode :mode/full-screen))
                          max-height max-content-height)}}
       [:div.flex-auto]
       nav-content
       [:div.flex-auto]]]]))
